/* eslint-disable prettier/prettier */
export default {
  'platform.title': 'Global digital asset trading platform',
  'title.adv': 'safe, stable and reliable',
  'is-sign-up': 'Have an account？',
  'platform.desc':
    'A blockchain digital asset trading platform that supports currency and fiat transactions, an elite team composed of top talents from many countries and fields in the world, has senior experience in system security, microsecond high load, and financial fields',
  'advantages.title': 'Multiple advantages',
  'advantages.desc': 'Provide users with safe, fast, convenient and standardized transaction services for digital assets',
  'advantages.1.title': 'Top Exchange Platform',
  'advantages.1.desc':
    'We are a leader in terms of real daily trading volume. With our licenses in the US and Canadian markets we sere a diverse market.',
  'advantages.2.title': 'Top Coins Available',
  'advantages.2.desc':
    'We list only top coins and carefully evaluated projects. Providing our customers access to only reliable assets is crucial for us.',
  'advantages.3.title': 'Top Business Services',
  'advantages.3.desc': 'We provide comprehensive pre- and post-  listing services with our dedicated team support and accelerator program.',
  'advantages.4.title': 'Optimized User Experience',
  'advantages.4.desc':
    'We have created a streamlined buying and selling experience with low rates. We understand our users’ needs and wants.',
  'advantages.5.title': 'Secure Trading Platform',
  'advantages.5.desc': 'We have a multi-tier and multi-cluster system architecture with 98% assets in cold storage.',
  'advantages.6.title': 'Reliable Customer Support',
  'advantages.6.desc':
    'We offer 24/7 dedicated support and trading assistance to all our clients. Our client’s satisfaction is our top priority.',
  'news.title': 'Announcement',
  'news.more': 'View more',
  'apps.title': 'Stay Connected ',
  'apps.scan_to_download': 'Scan to download',
  'apps.desc': 'Biconomy provides mobile Apps for trading NOW!',
  'android': 'Android',
  'ios': 'iOS',
  'statement.title': 'Statement',
  'statement.btn': 'Got it',
  'search-coin': 'Search',
  'no-disturb': "Don't disturb",
  //
  'home.1.title': 'Let your crypto assets work for you.',
  'home.1.desc': 'Biconomy is the safest platform to exchange cryptocurrency and build a digital portfolio. ',
  'home.1.input': 'Your Email Here',
  'pairing.title': 'Cryptocurrency Pairing',
  'pairing.rate': 'Rate',
  'testimonial.title': 'Our Clients Say…',
  'testimonial.1.desc':
    'Biconomy makes it so easy to trade and invest in crypto! I had no prior experience with crypto. Biconomy makes it so easy to use and it makes trading crypto fun. I use Biconomy everyday and it got me into options and future trading as well.',
  'testimonial.2.desc':
    "LOVE THE PLATFORM!!! It is user friendly and makes crypto trading less intimidating. I never had any problems with the app. Great customer service. I feel my crypto is secure in their hands and I love the different features it offeres that I just couldn't find those else where",
  'testimonial.1.project': 'CRAD Project',
  'testimonial.2.project': 'WAY-F Coin Project',
  'cta.title': 'Earn up to $166 worth of cryptocurrency by learning to trade',
  'cta.desc': 'Discover how specific cryptocurrencies work — and get a bit of each crypto to try out for yourself.',
  'cta.btn': 'Sign up and start earning now',
  'title.token': 'token',
  'title.symbol': 'symbol',
  'title.price': 'price',
  'title.24h': '24H',
  'title.cap': 'Market CAP',
  'title.volume': 'volume',
  'title.asset': 'asset',

  //
  'accelerator.hero.title': 'We have launched an accelerator program to help grow your project.',
  'accelerator.hero.desc':
    'Together with our partners LT Capital and INBlockchain  we are announcing an accelerator program for new promising projects that can revolutionize the world of blockchain and cryptocurrencies.',
  'accelerator.hero.btn': 'Learn more and apply',
  'accelerator.hero.1.title': 'Financing',
  'accelerator.hero.1.desc': 'Modular, realiable, OOP, simple fast, for scalable client-side code.',
  'accelerator.hero.2.title': 'Launchpad',
  'accelerator.hero.2.desc': 'Independent of any third-party libraries or frameworks.',
  'accelerator.hero.3.title': 'Project Development',
  'accelerator.hero.3.desc': 'Each component and module has descriptions and API.',
  'accelerator.hero.4.title': 'Project Promotion',
  'accelerator.hero.4.desc': 'We use it in our work. On this site too for the front and admin.',

  //
  'get_start': 'Get Started',
  'home.map':
    'We have a strong presence in North America, Southeast Asia, Eastern and Western Europe and Latin America. Our offices are located in Canada, CIS and across western Europe.',
  'home.information.text_1': 'Years',
  'home.information.text_2': 'Quarterly volume traded',
  'home.information.text_3': 'Countries',
  'home.information.text_4': 'Verified users',
  'home.features.title': 'Download the app and trade wherever you want',
  'home.features.title_1': 'Manage your portfolio',
  'home.features.text_1': 'Buy and sell popular digital currencies, keep track of them in the one place.',
  'home.features.title_2': 'Learn about crypto trading',
  'home.features.text_2': 'Invest in cryptocurrency slowly over time by scheduling daily, weekly, or monthly.',
  'home.features.title_3': 'Buy with credit card',
  'home.features.text_3': 'Thanks  to our partnership with ADVcash you can buy crypto directly with your credit card',
  'home.features.title_4': 'Mobile apps',
  'home.features.text_4': 'Stay on top of the markets with the Biconomy app for Android or iOS.',
  'home.readmore': 'Read more',
  'home.anniversary.title': '3rd Anniversary Celebration',
  'home.anniversary.desc':
    'To thank you for your support, Biconomy exchange organized a limited-time welfare giveaway for our 3rd anniversary',
  'Join Now': 'Join Now',
  'home.Service': 'Service',

  'home.banner_h1': 'Futures 2.0 is coming',
  'Trade Now': 'Trade Now',
  "home_banner_h1": "Blockchain + Economy = Biconomy",
  "home_banner_h2": "Buy, Trade & Hold any crypto - We are Bridging New Economy for You",
  "download_our_app": "Download our App",
  "home_download_desc": "Trusted by more than 500k + users worldwide",
  "email_address": "Email address"
};
